export default function authHeader() {
  let authToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');

  if (authToken) {
    return 'Bearer ' + authToken;
  } else {
    return null;
  }
}